import { MutationTree } from 'vuex'
import { AppState } from './state'

const mutations: MutationTree<AppState> = {
  IS_APP_LOADING_UPDATED: (state, isAppLoading: boolean) => {
    state.isAppLoading = isAppLoading
  },
  IS_PAGE_LOADING_UPDATED: (state, isPageLoading: boolean) => {
    state.isPageLoading = isPageLoading
  },
  IS_COMPONENT_LOADING_UPDATED: (state, isComponentLoading: boolean) => {
    state.isComponentLoading = isComponentLoading
  },
  APP_ERROR_UPDATED: (state, appError: string) => {
    if (state.appErrors.includes(appError)) {
      state.appErrors = state.appErrors.filter(e => e !== appError)
    } else {
      state.appErrors.push(appError)
    }
  },
  APP_NOTIFICATION_UPDATED: (state, notification: string) => {
    if (state.appNotifications.includes(notification)) {
      state.appNotifications = state.appNotifications.filter(
        n => n !== notification
      )
    } else {
      state.appNotifications.push(notification)
    }
  },
  APP_SUCCESS_UPDATED: (state, success: string) => {
    if (state.appSuccesses.includes(success)) {
      state.appSuccesses = state.appSuccesses.filter(s => s !== success)
    } else {
      state.appSuccesses.push(success)
    }
  },
}

export default mutations
